import { create } from 'zustand';
import { Classroom } from '../models/classroom';

interface ClassroomState {
  classrooms: Record<number, Classroom> | null;
  setClassrooms: (data: Record<number, Classroom>) => void;
  cachedResources: [string, string][] | null;
  setCachedResources: (data: [string, string][]) => void;
}

export const useClassroomStore = create<ClassroomState>((set) => ({
  classrooms: null,
  setClassrooms: (data) => set({ classrooms: data }),
  cachedResources: null,
  setCachedResources: (data) => set({ cachedResources: data })
}));
